import { CONTROLS_IMAGES } from '../../constants/image.constant';
import { icons } from './weather.constant';

export const getIconByType = type => {
    const icon = icons[type];
    return icon || CONTROLS_IMAGES.DEFAULT;
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/service/weather.helper.js